import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from '../../styles/tokens';
import { LinkTo } from '../linkTo/LinkTo';
import { Image } from '../Image/Image';

// Interface

export interface LogoWallProps {
  items: LogoWallItemProps[];
}

export interface LogoWallItemProps {
  image?: string;
  url: string;
}

// Styles

const StyledLogoWall = styled.div`
  ${({ theme: { space, media, maxMedia } }) => css`
    display: grid;
    column-gap: ${space.xLarge};

    img {
      width: 100%;
    }

    > * + * {
      position: relative;

      &:before {
        content: '';
        width: 1px;
        height: 100%;
        background-color: ${colors.brandTwo50};
        position: absolute;
        left: -${space.medium};
        top: 0;
      }
    }

    @media (max-width: ${maxMedia.medium}) {
      position: relative;
      grid-template-columns: 1fr 1fr;

      &:before {
        content: '';
        height: 1px;
        width: 100%;
        background-color: ${colors.brandTwo50};
        position: absolute;
        left: 0;
        top: 50%;
      }
    }

    @media (min-width: ${media.medium}) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  `};
`;

// JSX

export const LogoWall: FC<LogoWallProps> = ({ items, ...rest }) => {
  if (items.length <= 0) {
    return null;
  }

  return (
    <StyledLogoWall {...rest}>
      {items?.length >= 1 &&
        items.map(({ image, url }, index) => (
          <LinkTo to={url} key={index}>
            <Image src={image?.image?.localFile} />
          </LinkTo>
        ))}
    </StyledLogoWall>
  );
};

export default LogoWall;
